var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pickr-container",class:{'active': _vm.getActiveCustomColor()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }